<template>
  <el-dialog
    width="500px"
    title="同步商品"
    :visible.sync="props.isShowing"
    :before-close="cancel"
  >
    <div>确定将商品为选品中心推荐商品，同时</div>
    <el-radio-group style="margin-top: 24px" v-model="isPublish">
      <el-radio :label="1" style="display: block; margin-bottom: 12px"
        >发布商品</el-radio
      >
      <el-radio :label="0" style="display: block">不发布商品</el-radio>
    </el-radio-group>
    <div
      style="
        margin-top: 24px;
        display: flex;
        justify-content: end;
        align-items: center;
      "
    >
      <el-button size="mini" @click="cancel">取 消</el-button>
      <el-button
        :loading="isSync"
        size="mini"
        type="primary"
        @click="requestOfSync"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, getCurrentInstance } from "vue";

const app = getCurrentInstance().proxy;

const props = defineProps({
  isShowing: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["cancel", "syncSuccess"]);

const goodsId = ref("");
const isPublish = ref(0);
const isSync = ref(false);
defineExpose({ goodsId });

/**
 * 同步商品数据请求函数
 * 该函数用于向服务器发送批量同步商品的请求，包含商品ID、发布状态和供应商ID等参数
 * @returns {void}
 */
const requestOfSync = () => {
  isSync.value = true;
  const params = {
    goodsId: [goodsId.value],
    publishState: isPublish.value,
    supplierId: JSON.parse(localStorage.userInfo || "{}").suppliersId,
  };

  app.$axios
    .post(app.$api.goodsmanage.trade_goods_sync_product, params)
    .then((res) => {
      // 处理响应结果
      if (res.code === 0) {
        app.$message.success("操作成功，请前往选品中心推荐商品列表查看");
        syncSuccess();
      }
      isSync.value = false;
    });
};

/**
 * 切换显示状态的函数
 *
 * @description 该函数用于触发关闭事件，通知父组件当前组件需要关闭
 *
 * @returns {void}
 */
const cancel = () => {
  emit("cancel");
};

const syncSuccess = () => {
  emit("syncSuccess");
};
</script>

<style lang="scss" scoped></style>
